import Immutable from 'immutable';
import { createReducer } from '../utils';
import * as types from '../actionTypes/irSearchActionTypes';

const initialStateValue = {
  data_ready: false,
  data: [],
  receipt: {},
  lastUpdated: '',
  error: {},
};

const initialState = Immutable.fromJS(initialStateValue);


export default createReducer(initialState, {
  [types.REQUEST_CASE_DATA]: state =>
    state.mergeDeep(initialStateValue),

  [types.RECEIVE_CASE_DATA]: (state, action) => {
    const s = state.set('data', []).mergeDeep({
      data_ready: true,
      data: action.data,
      lastUpdated: action.lastUpdated,
      receipt: action.receipt,
    });
    return s;
  },

  [types.SERVICE_ERROR]: (state, action) =>
    state.mergeDeep({ data_ready: true, error: action.errors }),
});



// WEBPACK FOOTER //
// ./src/redux/reducers/irSearchReducer.js